import script from "./QuestionComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./QuestionComponent.vue?vue&type=script&lang=ts&setup=true"

import "./QuestionComponent.vue?vue&type=style&index=0&id=0d67c4bc&lang=scss"

const __exports__ = script;

export default __exports__